/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-cycle */
import Cookies from 'js-cookie';
import Overlay from 'javascripts/utils/overlay';
import initSocialEmbed from './social-embed';

class SocialEmbed {
  constructor($el, config) {
    this.$el = $el;
    this.embedCode = config?.embedCode ?? $el.getAttribute('data-embedcode');
    this.consentCookieName = config?.cookie ?? $el.getAttribute('data-cookie');

    this.Overlay = new Overlay({
      onConsent: this.onConsent,
      onGlobalConsent: this.onGlobalConsent,
      consentCookieName: this.consentCookieName,
      $el: this.$el,
    });

    this.checkForCookie();

    window.addEventListener('selectTab', () => {
      this.checkForCookie();
    });

    document.addEventListener('cookieAccepted', this.cookieChange);

    if (this.consentCookieName === 'bawu-datawrapper') {
      window.addEventListener('message', this.initDatawrapperIframeHeight);
    }
  }

  cookieChange = () => {
    this.deconstructor();
    this.checkForCookie();
  };

  checkForCookie = () => {
    const neededCookie = Cookies.get(this.consentCookieName) || null;

    if (!neededCookie || neededCookie !== 'accept') {
      this.Overlay.init();
      // Init overlay only if not active yet
      if (!this.$el.classList.contains('social-embed__cookie-overlay-active')) {
        this.$el.classList.add('social-embed__cookie-overlay-active');
      }
    } else {
      this.Overlay.destroy();
      this.toggleEmbed();
    }
  };

  onConsent = () => {
    this.toggleEmbed();
  };

  onGlobalConsent = () => {
    this.Overlay.destroy();
    this.toggleEmbed();
    initSocialEmbed();
  };

  toggleEmbed = () => {
    const $parent = this.$el;
    const regexSrc = /<script.*?src="(.*?)"/;
    const regex = /<script/;
    const isLoadedBefore = $parent.classList.contains(
      'social-embed__cookie-consent'
    );

    if (this.embedCode && !isLoadedBefore) {
      const embedHtml = decodeURIComponent(this.embedCode);

      $parent.insertAdjacentHTML('afterbegin', embedHtml);
      $parent.classList.remove('social-embed__cookie-overlay-active');
      $parent.classList.add('social-embed__cookie-consent');
      $parent.firstChild?.classList?.add('social-embed__injected');

      if (regexSrc.exec(embedHtml) !== null) {
        const scriptSrc = regexSrc.exec(embedHtml)[1];
        const newScript = document.createElement('script');
        newScript.setAttribute('async', true);
        newScript.src = scriptSrc;

        document.body.appendChild(newScript);
        $parent.querySelectorAll('script').forEach(($el) => $el.remove());
      } else if (regex.exec(embedHtml) !== null) {
        $parent.classList.remove('social-embed__cookie-overlay-active');
        $parent.classList.add('social-embed__cookie-consent');
        const script = embedHtml.substring(
          embedHtml.indexOf('<script'),
          embedHtml.lastIndexOf('</script>')
        );
        const fragment = document
          .createRange()
          .createContextualFragment(script);
        document.head.appendChild(fragment);
      }
    }

    setTimeout(() => {
      const $iframe = $parent?.querySelector('iframe');
      if ($iframe) {
        $iframe.contentWindow.focus();
      }
    }, 1500);
  };

  deconstructor = () => {
    this.$el.classList.remove('social-embed__cookie-consent');
    this.$el.classList.remove('social-embed__cookie-overlay-active');
    const $children = this.$el.querySelectorAll(
      ':scope > *:not(.social-embed__image):not(.js-overlay-template)'
    );
    for (let i = 0; i < $children.length; i += 1) {
      $children[i].parentNode.removeChild($children[i]);
    }
  };

  /**
   *
   * This is a snippet from the datawrapper feature (external source), that will normally be inserted with the iframe embed code. Sometimes the script will load too late or not at all, when added via injection, so we will add it here before the iframe is loaded. This script is not using any third part data so it is safe to use without consent.
   */
  initDatawrapperIframeHeight = (a) => {
    if (undefined !== a.data['datawrapper-height']) {
      // eslint-disable-next-line no-console
      console.log('received datawrapper height message');
      const e = document.querySelectorAll('iframe');

      // eslint-disable-next-line guard-for-in
      for (const t in a.data['datawrapper-height']) {
        for (let r = 0; r < e.length; r += 1) {
          if (e[r].contentWindow === a.source) {
            const i = `${a.data['datawrapper-height'][t]}px`;
            e[r].style.height = i;
          }
        }
      }
    }
  };
}

export default SocialEmbed;
